import { moneyFormatter } from "../../../../../utils/numeral/moneyFormatter";

export const stackedChartHeadingLabelFormatter = (value: number) =>
  `${moneyFormatter(value) ?? value}`;
